export var Platform;
(function (Platform) {
    Platform[Platform["All"] = 0] = "All";
    Platform[Platform["iOS"] = 1] = "iOS";
    Platform[Platform["Android"] = 2] = "Android";
})(Platform || (Platform = {}));
